(() => {
  if (window.__genkidamaLegalConsentReady) return;
  window.__genkidamaLegalConsentReady = true;

  const consentForButton = (button) => {
    const formId = button.getAttribute('form');
    const form = formId ? document.getElementById(formId) : button.closest('form');
    if (!form) return null;
    const escapedId = window.CSS?.escape ? CSS.escape(form.id) : form.id;
    return document.querySelector(`[data-genkidama-legal-checkbox][form="${escapedId}"]`)
      || form.querySelector('[data-genkidama-legal-checkbox]');
  };

  const validate = (checkbox, focus = true) => {
    if (!checkbox) return true;
    const wrapper = checkbox.closest('[data-genkidama-legal-consent]');
    const error = wrapper?.querySelector('[data-genkidama-legal-error]');
    const valid = checkbox.checked;
    checkbox.setAttribute('aria-invalid', valid ? 'false' : 'true');
    wrapper?.classList.toggle('is-invalid', !valid);
    if (error) error.hidden = valid;
    if (!valid && focus) {
      checkbox.focus({ preventScroll: true });
      wrapper?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return valid;
  };

  const selectedKd33Keys = () => {
    const keys = new Set();
    document.querySelectorAll('[data-kd33-item-checkbox]:checked').forEach((input) => {
      if (input.value) keys.add(input.value);
    });
    return Array.from(keys);
  };

  const kd33IsActive = () => Boolean(
    document.querySelector('[data-kd33-summary]') && selectedKd33Keys().length
  );

  const guestLoginFromCart = (button) => {
    const checkbox = consentForButton(button);
    const wrapper = checkbox?.closest('[data-genkidama-legal-consent]');
    if (!wrapper || wrapper.dataset.genkidamaCustomerAuthenticated !== 'false') return false;
    if (wrapper.dataset.genkidamaGuestCheckoutEnabled === 'true') return false;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    const loginUrl = wrapper.dataset.genkidamaCartLoginUrl || '/customer_authentication/login?return_to=%2Fcart';
    fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Rechtliche Zustimmung': 'AGB und Widerrufsbelehrung akzeptiert' } })
    }).then((response) => {
      if (!response.ok) throw new Error('Zustimmung konnte nicht gespeichert werden.');
      window.location.assign(loginUrl);
    }).catch((error) => {
      console.error('Anmeldung aus dem Warenkorb konnte nicht vorbereitet werden:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    return true;
  };

  const guestAddressFields = (wrapper) =>
    Array.from(wrapper.querySelectorAll('[data-genkidama-guest-address] [name]'));

  const guestAddressPayload = (wrapper) => {
    const payload = {};
    guestAddressFields(wrapper).forEach((field) => {
      if (field.type !== 'checkbox') payload[field.name] = field.value.trim();
    });
    return payload;
  };

  const setGuestAddressMessage = (wrapper, message, kind = 'error') => {
    const node = wrapper.querySelector('[data-genkidama-guest-address-message]');
    if (!node) return;
    node.textContent = message;
    node.hidden = !message;
    node.dataset.kind = kind;
  };

  const checkoutButtonsForWrapper = (wrapper) => {
    const checkbox = wrapper.querySelector('[data-genkidama-legal-checkbox]');
    const formId = checkbox?.getAttribute('form');
    if (!formId) return [];
    const form = document.getElementById(formId);
    return Array.from(document.querySelectorAll('button[name="checkout"], input[name="checkout"]'))
      .filter((button) => button.getAttribute('form') === formId || button.closest('form') === form);
  };

  const setGuestCheckoutReady = (wrapper, ready) => {
    checkoutButtonsForWrapper(wrapper).forEach((button) => {
      button.disabled = !ready;
      button.setAttribute('aria-disabled', ready ? 'false' : 'true');
      button.dataset.genkidamaGuestAddressLock = ready ? 'false' : 'true';
    });
  };

  const setAddressProtectionEnabled = (wrapper, enabled) => {
    wrapper.dataset.genkidamaAddressProtectionEnabled = enabled ? 'true' : 'false';
    const addressForm = wrapper.querySelector('[data-genkidama-guest-address]');
    if (addressForm) addressForm.hidden = !enabled;
    if (!enabled) {
      wrapper.dataset.genkidamaGuestAddressState = 'disabled';
      setGuestAddressMessage(wrapper, '');
      setGuestCheckoutReady(wrapper, true);
    }
  };

  const addressReadyForCheck = (payload) =>
    Boolean(payload.last_name && payload.address1 && payload.zip && payload.city);

  const checkGuestAddressNow = async (wrapper) => {
    if (wrapper.dataset.genkidamaGuestCheckoutEnabled !== 'true'
      || wrapper.dataset.genkidamaCustomerAuthenticated !== 'false'
      || wrapper.dataset.genkidamaAddressProtectionEnabled === 'false') return;
    const payload = guestAddressPayload(wrapper);
    const fingerprint = JSON.stringify(payload);
    setGuestCheckoutReady(wrapper, false);
    if (!addressReadyForCheck(payload)) {
      wrapper.dataset.genkidamaGuestAddressState = 'incomplete';
      setGuestAddressMessage(wrapper, '');
      return;
    }

    const requestNumber = String((Number(wrapper.dataset.genkidamaGuestAddressRequest || '0') + 1));
    wrapper.dataset.genkidamaGuestAddressRequest = requestNumber;
    wrapper.dataset.genkidamaGuestAddressState = 'checking';
    setGuestAddressMessage(wrapper, 'Adresse wird automatisch geprüft …', 'progress');
    try {
      const response = await fetch('/apps/genkidama/addrban/check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      });
      const result = await response.json().catch(() => ({}));
      if (wrapper.dataset.genkidamaGuestAddressRequest !== requestNumber) return;
      if (!response.ok || result.ok !== true) throw new Error('address_check_failed');
      wrapper.dataset.genkidamaGuestAddressFingerprint = fingerprint;
      if (result.address_status === 'invalid') {
        wrapper.dataset.genkidamaGuestAddressState = 'invalid';
        setGuestAddressMessage(wrapper, 'Diese Anschrift konnte nicht gefunden werden. Bitte prüfe Straße, Hausnummer, Postleitzahl und Ort.', 'blocked');
        return;
      }
      if (result.address_status === 'uncertain') {
        wrapper.dataset.genkidamaGuestAddressState = 'uncertain';
        const suggested = result.suggested_address || {};
        const label = [suggested.address1, [suggested.zip, suggested.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        setGuestAddressMessage(wrapper, label
          ? `Adresse nicht eindeutig. Meintest du: ${label}? Bitte korrigiere die Eingabe.`
          : 'Adresse nicht eindeutig. Bitte prüfe Straße, Hausnummer, Postleitzahl und Ort.', 'blocked');
        return;
      }
      if (result.blocked === true) {
        wrapper.dataset.genkidamaGuestAddressState = 'blocked';
        setGuestAddressMessage(wrapper, 'Diese Lieferadresse ist gesperrt. Über diese Adresse ist keine Bestellung möglich.', 'blocked');
        return;
      }
      wrapper.dataset.genkidamaGuestAddressState = 'allowed';
      setGuestAddressMessage(wrapper, 'Adresse geprüft. Du kannst jetzt zur Zahlung gehen.', 'allowed');
      setGuestCheckoutReady(wrapper, true);
    } catch (error) {
      if (wrapper.dataset.genkidamaGuestAddressRequest !== requestNumber) return;
      console.error('Automatische Gastadressprüfung fehlgeschlagen:', error);
      wrapper.dataset.genkidamaGuestAddressState = 'error';
      setGuestAddressMessage(wrapper, 'Die Adresse konnte gerade nicht geprüft werden. Bitte ändere ein Feld oder versuche es gleich erneut.');
    }
  };

  const scheduleGuestAddressCheck = (wrapper) => {
    if (wrapper.dataset.genkidamaAddressProtectionEnabled === 'false') return;
    window.clearTimeout(Number(wrapper.dataset.genkidamaGuestAddressTimer || '0'));
    setGuestCheckoutReady(wrapper, false);
    wrapper.dataset.genkidamaGuestAddressState = 'pending';
    const timer = window.setTimeout(() => checkGuestAddressNow(wrapper), 650);
    wrapper.dataset.genkidamaGuestAddressTimer = String(timer);
  };

  const validateGuestAddress = (wrapper) => {
    let firstInvalid = null;
    guestAddressFields(wrapper).forEach((field) => {
      if (field.type === 'checkbox') return;
      const valid = (!field.required || Boolean(field.value.trim())) && field.checkValidity();
      field.setAttribute('aria-invalid', valid ? 'false' : 'true');
      if (!valid && !firstInvalid) firstInvalid = field;
    });
    if (!firstInvalid) return true;
    setGuestAddressMessage(wrapper, 'Bitte fülle alle Pflichtfelder der Lieferadresse aus.');
    firstInvalid.focus({ preventScroll: true });
    firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return false;
  };

  const checkoutUrlForAddress = (payload) => {
    const params = new URLSearchParams();
    const mapping = {
      email: 'checkout[email]',
      first_name: 'checkout[shipping_address][first_name]',
      last_name: 'checkout[shipping_address][last_name]',
      address1: 'checkout[shipping_address][address1]',
      address2: 'checkout[shipping_address][address2]',
      zip: 'checkout[shipping_address][zip]',
      city: 'checkout[shipping_address][city]',
      country: 'checkout[shipping_address][country]',
      phone: 'checkout[shipping_address][phone]'
    };
    Object.entries(mapping).forEach(([key, parameter]) => {
      if (payload[key]) params.set(parameter, payload[key]);
    });
    return '/checkout?' + params.toString();
  };

  const guestCheckoutFromCart = (button) => {
    const checkbox = consentForButton(button);
    const wrapper = checkbox?.closest('[data-genkidama-legal-consent]');
    if (!wrapper || wrapper.dataset.genkidamaCustomerAuthenticated !== 'false'
      || wrapper.dataset.genkidamaGuestCheckoutEnabled !== 'true'
      || wrapper.dataset.genkidamaAddressProtectionEnabled === 'false') return false;
    if (button.dataset.genkidamaGuestBusy === 'true') return true;
    if (!validateGuestAddress(wrapper)) return true;

    const payload = guestAddressPayload(wrapper);
    button.dataset.genkidamaGuestBusy = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    setGuestAddressMessage(wrapper, 'Adresse wird geprüft …', 'progress');

    fetch('/apps/genkidama/addrban/check', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(async (response) => {
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.ok !== true) throw new Error('address_check_failed');
      if (result.address_status === 'invalid') {
        wrapper.dataset.genkidamaGuestAddressState = 'invalid';
        setGuestAddressMessage(wrapper, 'Diese Anschrift konnte nicht gefunden werden. Bitte prüfe Straße, Hausnummer, Postleitzahl und Ort.', 'blocked');
        return false;
      }
      if (result.address_status === 'uncertain') {
        wrapper.dataset.genkidamaGuestAddressState = 'uncertain';
        const suggested = result.suggested_address || {};
        const label = [suggested.address1, [suggested.zip, suggested.city].filter(Boolean).join(' ')].filter(Boolean).join(', ');
        setGuestAddressMessage(wrapper, label
          ? `Adresse nicht eindeutig. Meintest du: ${label}? Bitte korrigiere die Eingabe.`
          : 'Adresse nicht eindeutig. Bitte prüfe Straße, Hausnummer, Postleitzahl und Ort.', 'blocked');
        return false;
      }
      if (result.blocked === true) {
        wrapper.dataset.genkidamaGuestAddressState = 'blocked';
        setGuestAddressMessage(wrapper, 'Diese Lieferadresse ist gesperrt. Über diese Adresse ist keine Bestellung möglich.', 'blocked');
        return false;
      }
      const remember = wrapper.querySelector('[data-genkidama-guest-address-save]');
      try {
        if (remember?.checked) localStorage.setItem('genkidamaGuestCheckoutAddress', JSON.stringify(payload));
        else localStorage.removeItem('genkidamaGuestCheckoutAddress');
      } catch (_error) {}
      const root = window.Shopify?.routes?.root || '/';
      const cartResponse = await fetch(root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: {
          'Rechtliche Zustimmung': 'AGB und Widerrufsbelehrung akzeptiert',
          'Gastadresse bestätigt': 'Ja'
        } })
      });
      if (!cartResponse.ok) throw new Error('cart_update_failed');
      window.location.assign(checkoutUrlForAddress(payload));
      return true;
    }).then((navigating) => {
      if (navigating) return;
      delete button.dataset.genkidamaGuestBusy;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }).catch((error) => {
      console.error('Gastadresse konnte nicht geprüft werden:', error);
      setGuestAddressMessage(wrapper, 'Die Adresse konnte gerade nicht geprüft werden. Bitte versuche es erneut.');
      delete button.dataset.genkidamaGuestBusy;
      button.disabled = false;
      button.removeAttribute('aria-busy');
    });
    return true;
  };

  const restoreGuestAddresses = () => {
    let saved = null;
    try { saved = JSON.parse(localStorage.getItem('genkidamaGuestCheckoutAddress') || 'null'); } catch (_error) {}
    if (!saved || typeof saved !== 'object') return;
    document.querySelectorAll('[data-genkidama-guest-address]').forEach((form) => {
      Object.entries(saved).forEach(([name, value]) => {
        const field = Array.from(form.querySelectorAll('[name]')).find((item) => item.name === name);
        if (field && !field.value) field.value = String(value || '');
      });
      const remember = form.querySelector('[data-genkidama-guest-address-save]');
      if (remember) remember.checked = true;
    });
  };

  const initializeGuestAddressChecks = async () => {
    const wrappers = Array.from(document.querySelectorAll('[data-genkidama-legal-consent]'))
      .filter((wrapper) => wrapper.dataset.genkidamaCustomerAuthenticated === 'false'
        && wrapper.dataset.genkidamaGuestCheckoutEnabled === 'true');
    if (!wrappers.length) return;
    wrappers.forEach((wrapper) => setGuestCheckoutReady(wrapper, false));
    let enabled = true;
    try {
      const response = await fetch('/apps/genkidama/addrban/check', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ status_only: true })
      });
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.ok !== true) throw new Error('address_protection_status_failed');
      enabled = result.enabled !== false;
      wrappers.forEach((wrapper) => {
        const attribution = wrapper.querySelector('[data-genkidama-locationiq-attribution]');
        if (attribution) attribution.hidden = result.locationiq_attribution !== true;
      });
    } catch (error) {
      console.error('Status der Gastadressprüfung konnte nicht geladen werden:', error);
    }
    wrappers.forEach((wrapper) => {
      setAddressProtectionEnabled(wrapper, enabled);
      if (!enabled) return;
      const addressForm = wrapper.querySelector('[data-genkidama-guest-address]');
      if (addressForm) addressForm.hidden = false;
      if (wrapper.dataset.genkidamaCustomerAuthenticated === 'false'
        && wrapper.dataset.genkidamaGuestCheckoutEnabled === 'true') {
        setGuestCheckoutReady(wrapper, false);
        scheduleGuestAddressCheck(wrapper);
      }
    });
  };

  const openKd33Checkout = async (button) => {
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    const root = window.Shopify?.routes?.root || '/';
    try {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          attributes: {
            'Genkidama Teilzahlung Positionen': selectedKd33Keys().join('|'),
            'Rechtliche Zustimmung': 'AGB und Widerrufsbelehrung akzeptiert',
            'KD33 Teilzahlung': '33 Prozent Anzahlung, Restbetrag spaeter'
          }
        })
      });
      window.location.assign('/discount/KD33?redirect=/checkout');
    } catch (error) {
      console.error('KD33-Checkout konnte nicht vorbereitet werden:', error);
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-genkidama-legal-checkbox]')) validate(event.target, false);
    if (event.target.matches('[data-genkidama-guest-address] [name]')) {
      event.target.setAttribute('aria-invalid', 'false');
      const wrapper = event.target.closest('[data-genkidama-legal-consent]');
      if (wrapper) scheduleGuestAddressCheck(wrapper);
    }
  });

  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-genkidama-guest-address] [name]')) return;
    event.target.setAttribute('aria-invalid', 'false');
    const wrapper = event.target.closest('[data-genkidama-legal-consent]');
    if (wrapper) scheduleGuestAddressCheck(wrapper);
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button[name="checkout"], input[name="checkout"]');
    if (!button) return;
    const checkbox = consentForButton(button);
    if (!validate(checkbox)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (guestLoginFromCart(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (guestCheckoutFromCart(button)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (kd33IsActive()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openKd33Checkout(button);
    }
  }, true);

  document.addEventListener('submit', (event) => {
    const submitter = event.submitter;
    if (!submitter || submitter.name !== 'checkout') return;
    const checkbox = consentForButton(submitter);
    if (!validate(checkbox)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (guestLoginFromCart(submitter)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (guestCheckoutFromCart(submitter)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (kd33IsActive()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openKd33Checkout(submitter);
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      restoreGuestAddresses();
      initializeGuestAddressChecks();
    }, { once: true });
  } else {
    restoreGuestAddresses();
    initializeGuestAddressChecks();
  }
})();
